import React from 'react';
import { Button as AntButton } from 'antd';
import clsx from 'clsx';
import { ButtonProps as AntdButtonProps } from 'antd/es/button';

const AnchorButton = React.forwardRef<HTMLButtonElement, AntdButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <AntButton
        color="default"
        className={clsx('underline px-0', className)}
        ref={ref}
        variant="link"
        shape="round"
        {...props}
      >
        {children}
      </AntButton>
    );
  },
);

export default AnchorButton;
